import { FC, PropsWithChildren, useCallback } from 'react';

import { HttpClientProvider } from '@bonusly/http-client';
import { useRecognizeURL } from '@bonusly/url';

export const AppHttpClients: FC<PropsWithChildren> = ({ children, ...rest }) => {
	const loginURL = useRecognizeURL('/users/sign_in_start');
	const onUnauthorized = useCallback(() => {
		window.location.assign(loginURL);
	}, [loginURL]);

	return (
		<HttpClientProvider onUnauthorized={onUnauthorized} {...rest}>
			{children}
		</HttpClientProvider>
	);
};
